import React, { createContext, useState, useEffect } from 'react';
import useRequest from '../hooks/useRequest';
export const AppStateContext = createContext();

export const AppContextProvider = ({ children }) => {

    const { request } = useRequest()

    const [bannerList, setBannnerList] = useState([])

    return (
        <AppStateContext.Provider
            value={{
                bannerList
            }}>
            {children}
        </AppStateContext.Provider>
    );
};